/* eslint-disable max-len */

import { useCaseOptions } from 'Pods/ThreeDStudio/Components/MainPanel/Components/LeftSide/Components/ModelSettings/Components/UseCaseSelector/useCaseOptions'
import { USE_CASE } from 'Pods/ThreeDStudio/Store/constants'

const clampToRange = (value, { minimum, maximum } = {}) => {
  if (minimum == null || maximum == null) {
    return value
  }

  return Math.min(Math.max(Number(value), minimum), maximum)
}

const matchesPresetValue = (key, presetValue, settingValue, range) => {
  // The polycount control clamps a preset target the active range cannot hold,
  // so compare within it.
  if (key === 'targetPolycount') {
    return settingValue != null && settingValue !== ''
      && clampToRange(settingValue, range) === clampToRange(presetValue, range)
  }

  // An engine without polycount_mode passes the flag as undefined: it cannot tell
  // Standard (unlimited) from the target presets, so the key is left out of the match.
  if (key === 'isUnlimitedPolycount' && settingValue === undefined) {
    return true
  }

  return settingValue === presetValue
}

/**
 * Finds the use case whose preset the given model settings match, so a preset is
 * highlighted again once manual changes land back on its values. The preset provider
 * is not compared: switching engines never deselects a use case. No preset covers
 * extra quality, so settings with it on match none. On an engine with polycount_mode,
 * an unlimited run is the Standard preset whatever the other settings are, since
 * unlimited mode ignores the polygon target; the other presets need it off.
 *
 * @param {Object} modelSettings - The modelSettings slice. `isUnlimitedPolycount` is
 *   the effective flag, or undefined when the engine has no polycount_mode.
 * @param {Object} [range] - The active { minimum, maximum } polycount range.
 * @returns {string|undefined} One of USE_CASE values.
 */
export function findMatchingUseCase(modelSettings, range) {
  if (modelSettings.extraQuality) {
    return undefined
  }

  if (modelSettings.isUnlimitedPolycount === true) {
    return USE_CASE.STANDARD
  }

  const match = useCaseOptions.find(({ preset }) => (
    Object.entries(preset).every(([key, value]) => (
      key === 'provider' || matchesPresetValue(key, value, modelSettings[key], range)
    ))
  ))

  return match?.id
}
